import { formatPln } from '../catalog/money';
import { marginLabel } from './format';

/** The four key numbers (rule 4 of docs/wyglad.md: tiles only for these): revenue, costs, result, margin. */
export function Tiles({ revenue, revenueNote, costs, result, marginBp }: { revenue: number; revenueNote?: string | undefined; costs: number; result: number; marginBp: number | null }) {
  return (
    <dl className="fin-tiles">
      <div>
        <dt>Przychód</dt>
        <dd className="num" data-testid="tile-revenue">{formatPln(revenue)}</dd>
        {revenueNote && <dd className="fin-tile-note">{revenueNote}</dd>}
      </div>
      <div>
        <dt>Koszty</dt>
        <dd className="num" data-testid="tile-costs">{formatPln(costs)}</dd>
      </div>
      <div>
        <dt>Wynik</dt>
        <dd className={`num${result < 0 ? ' neg' : ''}`} data-testid="tile-result">
          {formatPln(result)}
        </dd>
      </div>
      <div>
        <dt>Marża</dt>
        <dd className={`num${marginBp !== null && marginBp < 0 ? ' neg' : ''}`} data-testid="tile-margin">
          {marginLabel(marginBp)}
        </dd>
      </div>
    </dl>
  );
}

export type Tile = { label: string; value: number; note?: string | undefined; negative?: boolean; testId: string };

/**
 * F45: the summary's key numbers (Szacowany dochód, Obroty, Wpłaty, Brak wpłat, Prognoza wpływów, Inwestycje, Koszty
 * stałe); a part the reader may not see is not passed at all.
 */
export function TileList({ tiles, label }: { tiles: Tile[]; label: string }) {
  return (
    <dl className="fin-tiles" aria-label={label}>
      {tiles.map((t) => (
        <div key={t.testId}>
          <dt>{t.label}</dt>
          <dd className={`num${t.negative ? ' neg' : ''}`} data-testid={t.testId}>
            {formatPln(t.value)}
          </dd>
          {t.note && <dd className="fin-tile-note">{t.note}</dd>}
        </div>
      ))}
    </dl>
  );
}
